import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    IGridOptions,
    IColumns,
    IExportExcel,
    ISearchPanel,
    IScroll,
    Toolbar,
    IColumnHiding,
    ICheckbox,
    IEditing,
    IColumnchooser,
    TiposdeDato,
    TiposdeFormato
} from 'app/interfaces';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { Datos } from 'app/models/datos.model';
import { AsignaBreadcrumb } from 'app/store/actions/permisos.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.states';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from "../../store/actions/utils.action";
import { FormpadreComponent } from "./formpadre/formpadre.component";
import { Router } from "@angular/router";

@Component({
    selector: 'app-catalogos',
    templateUrl: './catalogos.component.html',
    styleUrls: ['./catalogos.component.scss']
})
export class CatalogosComponent implements OnInit {
    // Grid variables
    gridOptions: IGridOptions;
    columns: IColumns[];
    exportExcel: IExportExcel;
    searchPanel: ISearchPanel;
    scroll: IScroll;
    toolbar: Toolbar[];
    columnHiding: IColumnHiding;
    Checkbox: ICheckbox;
    Editing: IEditing;
    Columnchooser: IColumnchooser;
    datos: any[] = [];
    modulo: any;
    datosevent: any;
    claveModulo = 'app-catalogos';
    constructor(public dialog: MatDialog,
        private readonly store: Store<AppState>,
        private baseService: BaseService,
        private srvcoal: CoalService,
        private router: Router) {
        this.store.dispatch(AsignaBreadcrumb({
            breadcrumb: null
        }));
    }

    ngOnInit(): void {
        const getStateUser = this.baseService.getUserData();

console.log("soy CATALOGOS")
        this.modulo = Datos.GetModulo(this.claveModulo, getStateUser.permissions.modules);
        if (this.modulo.breadcrumb) {
            const breadcrumb = Datos.GetConfiguracionBreadCrumb(this.modulo.breadcrumb);
            this.store.dispatch(AsignaBreadcrumb({
                breadcrumb
            }));
        }
        this.store.dispatch(MostrarSpinner())
        this.getdata();
        this.Grid();



    }
    getdata() {
        this.srvcoal.getService('catalogoDinamico/GetCatalogoDinamicoPadre?activo=1').subscribe((res: any) => {
            //console.log(res);
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.datos = res.recordsets[0];
                //console.log(this.datos)

            }
            this.store.dispatch(OcultarSpinner())
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner())
        });
    }
    Grid() {
        this.toolbar = [];
        /*
       Columnas de la tabla
       */
        try {
            this.columns = [
                {
                    caption: 'ID',
                    dataField: 'id',
                    allowEditing: false
                },
                {
                    caption: 'Nombre',
                    dataField: 'nombre',
                    name: 'nombre'
                },
                {
                    caption: 'Activo',
                    dataField: 'activo'
                }
            ];

            /*
            Parametros de Paginacion de Grit
            */
            const pageSizes = ['10', '25', '50', '100'];

            /*
            Parametros de Exploracion
            */
            this.exportExcel = { enabled: true, fileName: 'Listado de caja' };
            // ******************PARAMETROS DE COLUMNAS RESPONSIVAS EN CASO DE NO USAR HIDDING PRIORITY**************** */
            this.columnHiding = { hide: true };
            // ******************PARAMETROS DE PARA CHECKBOX**************** */
            this.Checkbox = { checkboxmode: 'multiple' };  // *desactivar con none*/
            // ******************PARAMETROS DE PARA EDITAR GRID**************** */
            this.Editing = { allowupdate: true }; // *cambiar a batch para editar varias celdas a la vez*/
            // ******************PARAMETROS DE PARA SELECCION DE COLUMNAS**************** */
            this.Columnchooser = { columnchooser: true };

            /*
            Parametros de Search
            */
            this.searchPanel = {
                visible: true,
                width: 200,
                placeholder: 'Buscar...',
                filterRow: true
            };

            /*
            Parametros de Scroll
            */
            this.scroll = { mode: 'standard' };

            // if (this.modulo.camposClase.find(x => x.nombre === 'verCaja')) {
            this.toolbar.push(
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 90,
                        text: 'Ver',
                        onClick: this.receiveMessage.bind(this, 'ver')
                    },
                    visible: false,
                    name: 'simple',
                    name2: 'multiple'
                }
            );
            // }

            //  if (this.modulo.camposClase.find(x => x.nombre === 'crearCaja')) {
            this.toolbar.push(
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 90,
                        text: 'Agregar',
                        onClick: this.receiveMessage.bind(this, 'crear')
                    },
                    visible: true
                }
            );
            // }

        } catch (error) {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 1 }));
        }
    }


    datosMessage($event) {
        try {
            //console.log($event)
            this.datosevent = $event.data;
        } catch (error) {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 1 }));
        }
    }
    receiveMessage($event) {
        //console.log($event);
        if ($event == "crear") {
            this.crear_nuevo();
        } else if ($event == "ver") {
            this.ver();
        }

    }
    ver() {
        //console.log("dtos ver", this.datosevent[0].id);
        this.router.navigateByUrl('/catalogos/editar?id=' + this.datosevent[0].id);
    }
    crear_nuevo() {
        let dialogRef = this.dialog.open(FormpadreComponent, {

            data: { data_sel: this.datosevent },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                //console.log(`Dialog result: ${result["nombre"].value}`);
                this.srvcoal.postService('catalogoDinamico/PostCatalogoDinamicoPadre', { nombre: result["nombre"].value }).subscribe((res: any) => {
                    //console.log(res);
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                    } else {
                        this.getdata()

                    }
                    this.store.dispatch(OcultarSpinner())
                }, (error: any) => {
                    this.store.dispatch(OcultarSpinner())
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                });
            }


        });

    }
    Actializar(data) {
        //console.log(data)
        if (data.data) {
            //console.log(`Dialog result: ${data.data}`);
            this.srvcoal.putService('catalogoDinamico/PutCatalogoDinamicoPadre', data.data).subscribe((res: any) => {
                //console.log(res);
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                } else {
                    this.getdata()

                }
                this.store.dispatch(OcultarSpinner())
            }, (error: any) => {
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                this.store.dispatch(OcultarSpinner())
            });
        }
    }

}
